export enum ExportType {
  AWARDS = "AWARDS",
  REQUEST = "REQUEST",
}
